import { render } from "./PortfolioModalTwo.vue?vue&type=template&id=7f4a1a51"
import script from "./PortfolioModalTwo.vue?vue&type=script&lang=js"
export * from "./PortfolioModalTwo.vue?vue&type=script&lang=js"
script.render = render

export default script